export const LEGACY_APPLICATION_SHOW_ROUTE = 'authenticated.tas.applications.show';
export const MANAGE_ROUTE = 'authenticated.tas.applications.manage';

// The program types that have a manage screen. Values match the
// typeClassifications handled in `app/routes/authenticated/tas/applications/show.ts`'s
// afterModel routeMappings (which route every application to its `-guided` variant for
// the `new` flow) — manage itself is a single shared route, not one per guided group.
const MANAGEABLE_TYPES = new Set([
  'TAS.ProgramType.2',
  'TAS.ProgramType.3',
  'TAS.ProgramType.4.2',
  'TAS.ProgramType.4.3',
]);

/**
 * Resolves the route for viewing an existing TAS application: the shared `manage`
 * screen when `tasCourseManagement` is on and the application's program type is
 * manageable, otherwise the legacy show route.
 */
export function applicationDetailRoute(
  typeClassification: string | null | undefined,
  isManageScreenEnabled: boolean
): string {
  if (!isManageScreenEnabled) {
    return LEGACY_APPLICATION_SHOW_ROUTE;
  }
  const isManageable = typeClassification ? MANAGEABLE_TYPES.has(typeClassification) : false;
  return isManageable ? MANAGE_ROUTE : LEGACY_APPLICATION_SHOW_ROUTE;
}
